/* Kuehn Doggear Theme: Produktseite (Galerie, Variantenwahl, Mengenwahl). */
(function () {
  'use strict';

  /* Im Theme-Editor kann das Skript mit dem Abschnitt erneut geladen werden: nur neu starten, nichts doppelt binden. */
  if (window.KuehnProdukt) {
    window.KuehnProdukt.start();
    return;
  }

  var wenigBewegung = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Mengenwahl: Plus und Minus am Zahlenfeld ---------- */
  function mengeStarten(wurzel) {
    wurzel.querySelectorAll('[data-menge]').forEach(function (menge) {
      var feld = menge.querySelector('[data-menge-feld]');
      var minus = menge.querySelector('[data-menge-minus]');
      var plus = menge.querySelector('[data-menge-plus]');
      if (!feld || !minus || !plus || menge.dataset.bereit) return;
      menge.dataset.bereit = 'ja';

      var min = parseInt(feld.min, 10);
      var max = parseInt(feld.max, 10);
      if (isNaN(min)) min = 1;

      function lesen() {
        var zahl = parseInt(feld.value, 10);
        return isNaN(zahl) ? min : zahl;
      }
      function abgleichen() {
        var zahl = lesen();
        minus.disabled = zahl <= min;
        plus.disabled = !isNaN(max) && zahl >= max;
      }
      function setzen(zahl) {
        if (zahl < min) zahl = min;
        if (!isNaN(max) && zahl > max) zahl = max;
        feld.value = String(zahl);
        abgleichen();
        feld.dispatchEvent(new Event('change', { bubbles: true }));
      }

      minus.addEventListener('click', function () { setzen(lesen() - 1); });
      plus.addEventListener('click', function () { setzen(lesen() + 1); });
      feld.addEventListener('input', abgleichen);
      abgleichen();
    });
  }

  /* ---------- Galerie: Vorschaubilder blaettern die Buehne ---------- */
  function galerieStarten(galerie) {
    var spur = galerie.querySelector('[data-galerie-spur]');
    if (!spur) return null;
    var bilder = Array.prototype.slice.call(spur.querySelectorAll('[data-galerie-bild]'));
    var daumen = Array.prototype.slice.call(galerie.querySelectorAll('[data-galerie-daumen]'));
    var aktiv = -1;
    var ruhe = null;

    function markieren(index) {
      if (index === aktiv) return;
      aktiv = index;
      daumen.forEach(function (eintrag, i) {
        if (i === index) eintrag.setAttribute('aria-current', 'true');
        else eintrag.removeAttribute('aria-current');
      });
    }

    function zeigen(index) {
      if (index < 0 || index >= bilder.length) return;
      markieren(index);
      spur.scrollTo({ left: index * spur.clientWidth, behavior: wenigBewegung ? 'auto' : 'smooth' });
    }

    daumen.forEach(function (eintrag, i) {
      eintrag.addEventListener('click', function (e) {
        e.preventDefault();
        zeigen(i);
      });
    });

    /* Beim Wischen oder Scrollen: markieren, sobald die Spur zur Ruhe kommt */
    spur.addEventListener('scroll', function () {
      clearTimeout(ruhe);
      ruhe = setTimeout(function () {
        if (spur.clientWidth) markieren(Math.round(spur.scrollLeft / spur.clientWidth));
      }, 120);
    }, { passive: true });

    markieren(spur.clientWidth ? Math.round(spur.scrollLeft / spur.clientWidth) : 0);

    return {
      zeigeMedium: function (id) {
        for (var i = 0; i < bilder.length; i++) {
          if (bilder[i].getAttribute('data-medium') === String(id)) {
            zeigen(i);
            return;
          }
        }
      }
    };
  }

  /* ---------- Variantenwahl: Flaechen je Option setzen die passende Variante ---------- */
  function variantenStarten(produkt, galerie) {
    /* Die Variantendaten stehen im Kaufformular: so findet sich das Formular ohne eigenes Merkmal am <form> */
    var datenKnoten = produkt.querySelector('[data-varianten]');
    var formular = datenKnoten ? datenKnoten.closest('form') : null;
    if (!formular) return;

    var daten;
    try {
      daten = JSON.parse(datenKnoten.textContent);
    } catch (fehler) {
      return;
    }
    var varianten = daten.varianten || [];
    var texte = daten.texte || {};

    var auswahl = formular.querySelector('[data-varianten-select]');
    var gruppen = Array.prototype.slice.call(formular.querySelectorAll('[data-option]'));
    if (!auswahl || !gruppen.length) return;

    var knopf = formular.querySelector('[data-kaufen]');
    var knopfText = knopf ? knopf.querySelector('span') : null;
    var status = formular.querySelector('[data-status]');
    var express = formular.querySelector('[data-express]');
    var preis = produkt.querySelector('[data-preis]');

    function gewaehlt() {
      return gruppen.map(function (gruppe) {
        var radio = gruppe.querySelector('[data-option-wert]:checked');
        return radio ? radio.value : null;
      });
    }

    function finde(werte) {
      for (var i = 0; i < varianten.length; i++) {
        var optionen = varianten[i].optionen || [];
        var passt = true;
        for (var k = 0; k < werte.length; k++) {
          if (optionen[k] !== werte[k]) {
            passt = false;
            break;
          }
        }
        if (passt) return varianten[i];
      }
      return null;
    }

    /* Durchgestrichen wird, was zusammen mit der uebrigen Auswahl nicht lieferbar ist */
    function verfuegbarkeitMarkieren(werte) {
      gruppen.forEach(function (gruppe, stelle) {
        gruppe.querySelectorAll('[data-option-wert]').forEach(function (radio) {
          var probe = werte.slice();
          probe[stelle] = radio.value;
          var variante = finde(probe);
          if (variante && variante.verfuegbar) radio.removeAttribute('data-aus');
          else radio.setAttribute('data-aus', '');
        });
      });
    }

    function anwenden(variante, vomNutzer) {
      /* Beim Start stimmt die Seite meist schon: dann nichts anfassen, damit Screenreader nichts doppelt ansagen */
      var wechsel = vomNutzer || !variante || String(variante.id) !== auswahl.value;
      if (variante) {
        auswahl.value = String(variante.id);
        if (wechsel && preis && variante.preis_html) preis.innerHTML = variante.preis_html;
        if (vomNutzer) {
          if (galerie && variante.medium) galerie.zeigeMedium(variante.medium);
          if (window.history && window.history.replaceState) {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', variante.id);
            window.history.replaceState(window.history.state, '', url.toString());
          }
        }
      }
      var kaufbar = !!(variante && variante.verfuegbar);
      var zustand = kaufbar ? texte.kaufen : variante ? texte.ausverkauft : texte.nicht_verfuegbar;
      if (knopf) knopf.disabled = !kaufbar;
      if (knopfText && zustand) knopfText.textContent = zustand;
      if (status && wechsel) status.textContent = kaufbar ? '' : zustand || '';
      if (express) express.hidden = !kaufbar;
    }

    function abgleichen(vomNutzer) {
      var werte = gewaehlt();
      verfuegbarkeitMarkieren(werte);
      anwenden(finde(werte), vomNutzer);
    }

    formular.addEventListener('change', function (e) {
      if (e.target && e.target.matches('[data-option-wert]')) abgleichen(true);
    });

    /* Start und Rueckkehr ueber "Zurueck": der Browser kann die Radio-Felder wiederherstellen, alles andere folgt ihnen */
    abgleichen(false);
    window.addEventListener('pageshow', function () {
      if (document.contains(formular)) abgleichen(false);
    });
  }

  function start(wurzel) {
    (wurzel || document).querySelectorAll('[data-produkt]').forEach(function (produkt) {
      if (produkt.dataset.bereit) return;
      produkt.dataset.bereit = 'ja';
      mengeStarten(produkt);
      var galerieKnoten = produkt.querySelector('[data-galerie]');
      variantenStarten(produkt, galerieKnoten ? galerieStarten(galerieKnoten) : null);
    });
  }

  window.KuehnProdukt = { start: start };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(); });
  } else {
    start();
  }

  /* Im Theme-Editor neu geladene Abschnitte neu starten */
  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
})();
